<div class="job-fees-dialog-container">
    <h2 mat-dialog-title class="text-center !mb-6 font-bold text-xl">Job Fees</h2>

    <mat-dialog-content>
        <div class="flex items-center gap-2 mb-4 px-2">
            <mat-icon class="text-primary-800">info</mat-icon>
            <p class="italic text-base text-info-500 !mb-0">Please enter the final fee for all services marked as “Contact to Client” before confirming billing</p>
        </div>
        <mat-card>
            <mat-card-content>
                <form [formGroup]="form">
                    <table class="w-full table-fixed mt-4">
                        <colgroup>
                            <col style="width: 30%;"> <!-- Item -->
                            <col style="width: 15%;"> <!-- Rate -->
                            <col style="width: 10%;"> <!-- Quantity -->
                            <col style="width: 15%;"> <!-- Tax -->
                            <col style="width: 15%;"> <!-- Official Fee -->
                            <col style="width: 15%;"> <!-- Amount -->
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="text-left px-2 py-2">
                                    <span class="mat-title !text-sub !mb-0 text-darkGray font-bold">Item</span>
                                </th>
                                <th class="text-center px-2 py-2">
                                    <span class="mat-title !text-sub !mb-0 text-darkGray font-bold">Rate
                                        ({{form.currency}})</span>
                                </th>
                                <th class="text-center px-2 py-2">
                                    <span class="mat-title !text-sub !mb-0 text-darkGray font-bold">Quantity</span>
                                </th>
                                <th class="text-center px-2 py-2">
                                    <span class="mat-title !text-sub !mb-0 text-darkGray font-bold">Tax
                                        ({{form.taxRate}}%)</span>
                                </th>
                                <th class="text-center px-2 py-2">
                                    <span class="mat-title !text-sub !mb-0 text-darkGray font-bold">Official Fee
                                        ({{form.currency}})</span>
                                </th>
                                <th class="text-center px-2 py-2">
                                    <span class="mat-title !text-sub !mb-0 text-darkGray font-bold">Amount
                                        ({{form.currency}})</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody formArrayName="items">
                            <tr *ngFor="let item of items.controls; let i = index" [formGroupName]="i"
                                class="service-item hover:bg-gray-50 py-2 rounded border-b border-gray-100 last:border-0">
                                <!-- Item Name -->
                                <td class="pr-2 px-2 py-2">
                                    <div class="flex items-center">
                                        <p class="!text-sub !mb-0 truncate" [matTooltip]="item.controls.name.value">
                                            {{ item.controls.name.value }}
                                            <span class="text-lightGray lowercase" *ngIf="item.controls.billingCycleLabel.value">
                                                (billed {{ item.controls.billingCycleLabel.value }})
                                            </span>
                                        </p>
                                        <mat-icon *ngIf="item.controls.isContactToClient.value"
                                                  style="color: #3A4856;" class="!text-base ml-1" matTooltip="Contact to Client">
                                            info
                                        </mat-icon>
                                    </div>
                                </td>

                                <!-- Rate Input -->
                                <td class="px-2 py-2">
                                    <mat-form-field appearance="outline" class="w-full">
                                        <input matInput type="text" [formControl]="item.controls.rate" numericInputFormatter [numericInputFormatterDecimalPlaces]="2"/>
                                    </mat-form-field>
                                </td>

                                <!-- Quantity Input -->
                                <td class="text-center px-2 py-2">
                                    <mat-form-field appearance="outline" class="w-full">
                                        <input matInput type="text" [formControl]="item.controls.quantity" numericInputFormatter [numericInputFormatterDecimalPlaces]="0" (blur)="onQuantityBlur(item.controls.quantity)"/>
                                    </mat-form-field>
                                </td>

                                <!-- Tax Checkbox -->
                                <td class="text-center px-2 py-2">
                                    <mat-checkbox color="primary" [formControl]="item.controls.taxEnabled" class="!mr-0"></mat-checkbox>
                                </td>

                                <!-- Official Fee Display -->
                                <td class="text-center px-2 py-2">
                                    <span class="!text-sub !mb-0 font-medium text-gray-700">
                                        {{ item.controls.officialFee.value | number:'1.0-2' }}
                                    </span>
                                </td>

                                <!-- Amount Display -->
                                <td class="text-center px-2 py-2">
                                    <span class="!text-sub !mb-0 font-medium text-gray-700">
                                        {{ form.getLineAmount(i) | number:'1.0-2' }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <mat-divider class="!my-6"></mat-divider>

                    <!-- Summary Section -->
                    <section class="summary-container px-2">
                        <!-- Subtotal -->
                        <div class="flex w-full mb-2 items-center">
                            <div class="flex-grow basis-2/5 w-2/5">
                                <p class="!text-sub !mb-0 font-bold text-gray-700"><strong>Subtotal</strong></p>
                            </div>
                            <!-- Spacer cols to push amount to right -->
                            <div class="flex-grow basis-3/5 w-3/5 text-right">
                                <span class="!text-sub !mb-0 text-gray-700">
                                    {{ form.subtotal | smartCurrency:form.currency:'':'symbol':null:true }}
                                </span>
                            </div>
                        </div>

                        <!-- GST/VAT -->
                        <div class="flex w-full mb-2 items-center">
                            <div class="flex-grow basis-2/5 w-2/5">
                                <p class="!text-sub !mb-0 font-bold text-gray-700"><strong>GST/VAT {{ form.taxRate }}%</strong></p>
                            </div>
                            <div class="flex-grow basis-3/5 w-3/5 text-right">
                                <span class="!text-sub !mb-0 text-gray-700">
                                    {{ form.tax | smartCurrency:form.currency:'':'symbol':null:true }}
                                </span>
                            </div>
                        </div>

                        <!-- Official Fees -->
                        <div class="flex w-full mb-2 items-center">
                            <div class="flex-grow basis-2/5 w-2/5">
                                <p class="!text-sub !mb-0 font-bold text-gray-700">Official fees</p>
                            </div>
                            <div class="flex-grow basis-3/5 w-3/5 text-right">
                                <span class="!text-sub !mb-0 text-gray-700">
                                    <ng-container *ngIf="form.officialFees > 0; else naTemp">
                                        {{ form.officialFees | smartCurrency:form.currency:'':'symbol':null:true }}
                                    </ng-container>
                                    <ng-template #naTemp>N/A</ng-template>
                                </span>
                            </div>
                        </div>

                        <mat-divider class="!my-6"></mat-divider>

                        <!-- Total -->
                        <div class="flex w-full mb-2 items-end">
                            <div class="flex-grow basis-2/5 w-2/5">
                                <p class="!text-sub !mb-0 font-bold text-lg text-gray-800"><strong>Total</strong></p>
                            </div>

                            <div class="flex-grow basis-3/5 w-3/5 text-right flex flex-col items-end">
                                <span class="!text-sub !mb-0 font-bold text-lg text-gray-800">
                                    {{ form.total | smartCurrency:form.currency:'':'symbol':null:true }}
                                </span>
                            </div>
                        </div>

                        <p *ngIf="form.hasError('stripeChargeValidation')" class="text-sm !text-red-600 mt-2 mb-0 text-right">
                            {{ billingPreviewValidationErrorMessage }}
                        </p>

                        <p *ngIf="form.hasError('billingPreviewUnavailable')" class="text-sm !text-red-600 mt-2 mb-0 text-right">
                            Unable to load billing preview right now. Please try again.
                        </p>
                    </section>

                </form>
            </mat-card-content>
        </mat-card>

        <div *ngIf="form.invalid && invalidReasons.length > 0"
             class="mt-4 p-4 rounded-lg bg-red-50 border border-red-200">
            <p class="text-error-600 !mb-2 font-semibold flex items-center text-sm">
                <mat-icon color="warn" class="mr-2">error_outline</mat-icon>
                Please resolve the following issues before proceeding:
            </p>
            <ul class="list-disc list-inside text-red-700 ml-6 text-sm">
                <li *ngFor="let reason of invalidReasons">{{ reason }}</li>
            </ul>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="center" class="!pb-6 !gap-4 !mt-4">
        <button mat-raised-button (click)="onCancel()">
            Cancel
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="onSave()"
            [disabled]="form.invalid || !hasFeeChanges"
        >
            Save
        </button>
    </mat-dialog-actions>
</div>

<ng-template #confirmBillingDialogTemplate>
  <div class="py-4">
    <p class="text-center">Are you sure the billing is correct?</p>
  </div>
</ng-template>
